var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<!-- copying notes this is a common ui component -- using the 'side panel template -->\n\n<div id=\""
    + container.escapeExpression(((helper = (helper = helpers.paneId || (depth0 != null ? depth0.paneId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paneId","hash":{},"data":data}) : helper)))
    + "\" class=\"sub-side-content no-padding\">\n\n    <div class=\"spWr\">\n\n        <div id=\"fr-header\" class=\"sp-header\" data-region=\"true\"></div>\n\n        <div class=\"sp-body\">\n\n            <div id=\"fr-body\">\n\n                <div id=\"fr-search\" data-region=\"true\"></div>\n\n                <div id=\"find-and-redact-results\" data-region=\"true\"></div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/template.hbs
 ** module id = 656
 ** module chunks = 0
 **/